export default __webpack_public_path__ + "static/background-15bc032ce82c5f9bbbf15ad2ddd311e3.jpg";